import React from "react";
import LegalLayout from "@/components/solanova/LegalLayout";

const H2 = ({ children }) => (
  <h2 className="font-display text-xl md:text-2xl text-white font-light mt-10 mb-3">
    {children}
  </h2>
);

export default function Datenschutz() {
  return (
    <LegalLayout
      title="Datenschutzerklärung"
      eyebrow="Privatsphäre"
      testId="datenschutz-page"
    >
      <p>
        Solanova GmbH (nachfolgend „wir“) nimmt den Schutz Ihrer persönlichen Daten sehr
        ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend
        dem revidierten Schweizer Datenschutzgesetz (revDSG) sowie – sofern anwendbar –
        der EU-Datenschutz-Grundverordnung (DSGVO).
      </p>

      <H2>1. Verantwortliche Stelle</H2>
      <p>
        Solanova GmbH<br />
        Vogelherd 5, 9225 Wilen-Gottshaus, Schweiz<br />
        E-Mail: info@solanova.ch · Telefon: +41 76 572 55 08
      </p>

      <H2>2. Welche Daten wir bearbeiten</H2>
      <p>
        Beim Besuch unserer Website werden technisch notwendige Daten (IP-Adresse, Browsertyp,
        Zugriffszeitpunkt, aufgerufene Seite) verarbeitet. Wenn Sie das Kontaktformular oder
        den Solar-Check ausfüllen, erfassen wir die von Ihnen angegebenen Daten:
      </p>
      <ul className="list-disc pl-6 space-y-1.5 text-white/65">
        <li>Name, E-Mail-Adresse, Telefonnummer</li>
        <li>PLZ, Ort, Angaben zum Objekt (z.B. Dachform, Stromverbrauch)</li>
        <li>Inhalte Ihrer Nachricht</li>
      </ul>

      <H2>3. Zweck der Datenbearbeitung</H2>
      <p>
        Wir verwenden Ihre Daten ausschliesslich, um Ihre Anfrage zu bearbeiten, Ihnen eine
        individuelle Offerte zu erstellen und Sie zu Ihrem Projekt zu beraten. Es findet keine
        Weitergabe an Dritte zu Werbezwecken statt.
      </p>

      <H2>4. Aufbewahrungsdauer</H2>
      <p>
        Personenbezogene Daten werden so lange aufbewahrt, wie es zur Erfüllung des Zwecks
        notwendig ist bzw. gesetzliche Aufbewahrungsfristen (z.B. 10 Jahre für geschäftliche
        Unterlagen) dies vorschreiben.
      </p>

      <H2>5. Dienstleister und Auftragsbearbeiter</H2>
      <p>
        Zur technischen Bereitstellung der Website und zum Versand von E-Mails setzen wir
        sorgfältig ausgewählte Dienstleister ein. Diese sind vertraglich verpflichtet, Ihre
        Daten ausschliesslich gemäss unseren Weisungen zu bearbeiten:
      </p>
      <ul className="list-disc pl-6 space-y-1.5 text-white/65">
        <li>Hosting & technische Infrastruktur (Schweiz / EU)</li>
        <li>E-Mail-Versand: Resend (USA) – Versand von Kontakt- und Lead-Mails</li>
      </ul>

      <H2>6. Ihre Rechte</H2>
      <p>Sie haben jederzeit das Recht auf:</p>
      <ul className="list-disc pl-6 space-y-1.5 text-white/65">
        <li>Auskunft über die zu Ihrer Person gespeicherten Daten</li>
        <li>Berichtigung unrichtiger Daten</li>
        <li>Löschung oder Sperrung Ihrer Daten</li>
        <li>Widerspruch gegen die Bearbeitung</li>
        <li>Datenherausgabe in einem gängigen Format (Datenportabilität)</li>
      </ul>
      <p>
        Für die Ausübung Ihrer Rechte genügt eine formlose Mitteilung an{" "}
        <span className="link-bronze">info@solanova.ch</span>.
      </p>

      <H2>7. Cookies</H2>
      <p>
        Unsere Website verwendet ausschliesslich technisch notwendige Cookies. Tracking-
        oder Marketing-Cookies werden nur mit Ihrer ausdrücklichen Einwilligung gesetzt.
      </p>

      <H2>8. Änderungen</H2>
      <p>
        Wir behalten uns vor, diese Datenschutzerklärung jederzeit anzupassen, um sie an
        rechtliche Entwicklungen oder Änderungen unserer Leistungen anzupassen.
      </p>
    </LegalLayout>
  );
}
